import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import LeftMenuDrawer from './components/LeftMenuDrawer';
import { useMyProfileQuery } from '../../services/profileService/profile-api';
import { ticketEasyTheme } from './TicketEasyTheme';
import { CssBaseline, Box } from '@mui/material';
import './TicketEasy.css';

const TicketEasyApp: React.FC = () => {
  useMyProfileQuery();
  
  return (
    <ThemeProvider theme={ticketEasyTheme}>
      <CssBaseline />
      <Box 
        className="ticketEasy-module"
        sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          height: '100vh', 
          overflow: 'hidden'
        }}
      >
        <LeftMenuDrawer />
      </Box>
    </ThemeProvider>
  );
};

export { TicketEasyApp };
